import { Transition } from '@uirouter/angularjs';
import { ILazyLoad } from 'oclazyload';
import { TransitionBarService } from '../ui/transition-bar/transition-bar.service';
import { isMoment, Moment } from 'moment';
import * as moment from 'moment';
import { cloneDeep, forEach, isObject, values } from 'lodash-es';

export class Helpers {
  static createDateFromString(timestamp: any) {
    return timestamp ? new Date(timestamp) : null;
  }
  //
  // static checkDates(dateFrom: Moment, dateTo: Moment): {dateFrom: Moment, dateTo: Moment } {
  //   let fromClone = cloneDeep(dateFrom);
  //   let toClone = cloneDeep(dateTo);
  //   if (fromClone && toClone) {
  //     console.log(toClone.isBefore(fromClone));
  //     if (fromClone.isAfter(toClone)) {
  //       toClone = dateTo;
  //       fromClone = dateFrom;
  //       return;
  //     } else if (toClone.isAfter(moment())) {
  //       toClone = dateTo;
  //       return;
  //     }
  //   } else if (fromClone && !toClone) {
  //     if (fromClone.isAfter((moment()))) {
  //       fromClone = dateFrom;
  //       return;
  //     }
  //   } else if (toClone && !fromClone) {
  //     if (toClone.isAfter(moment())) {
  //       toClone = dateTo;
  //       return;
  //     }
  //   }
  // }

  static createDatePeriod(exp_months: number): string {
    if (exp_months <= 0) {
      return;
    }
    const months_in_years = 12;
    const years = Math.floor(exp_months / months_in_years);
    const months = exp_months - years * months_in_years;
    const yearsText = years > 0 ? `${years} years and` : '';
    const monthsText = `${months} months`;
    console.log(yearsText + monthsText);
    return `${yearsText} ${monthsText}`;
  }

  static setTransitionBarState(transition: Transition, isActive: boolean) {
    const tbService: TransitionBarService = transition
      .injector()
      .get('TransitionBarService');
    tbService.barActive(isActive);
  }

  // purgatory 2.0
  static removeEmptyAndParseDate(obj: any = {}) {
    if (Array.isArray(obj) && obj.length) {
      obj = obj.filter((value) => !this.isEmpty(value));
    } else if (Array.isArray(obj) && !obj.length) {
      obj = [];
    }

    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] && isMoment(obj[key])) {
        obj[key] = obj[key].endOf('d').format();
      } else if (obj.hasOwnProperty(key) && isObject(obj[key])) {
        if (Object.values(obj[key]).length) {
          obj[key] = this.removeEmptyAndParseDate(obj[key]);
        }
      } else if (obj[key] === null) {
        obj[key] = undefined;
      }
    }

    return obj;
  }

  static ParseDate(obj: any = {}) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && isMoment(obj[key])) {
        obj[key] = obj[key].format();
      }
    }
    return obj;
  }

  static isEmpty(obj: any = {}): boolean {
    const emptyArray = [0];
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && Array.isArray(obj[key])) {
        emptyArray.push(obj[key].length);
      } else if (obj.hasOwnProperty(key) && typeof obj[key] === 'object') {
        emptyArray.push(this.isEmpty(obj[key]) ? 0 : 1);
      } else if (
        key !== '$$hashKey' &&
        key !== '_id' &&
        obj.hasOwnProperty(key) &&
        typeof obj[key] !== 'boolean' &&
        obj[key]
      ) {
        emptyArray.push(1);
        break;
      }
    }
    return emptyArray.reduce((a, b) => a + b) === 0;
  }

  static oclazyloadFromTransition(transition: Transition): ILazyLoad {
    return transition.injector().get('$ocLazyLoad');
  }

  static kebabCase(value: string): string {
    return value
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/\s+/g, '-')
      .toLowerCase();
  }

  static makeSearchQuery(obj): string {
    if (typeof obj !== 'object') {
      return '';
    }
    return Object.keys(obj)
      .map((key) => `${key}=${encodeURIComponent(obj[key])}`)
      .join('&');
  }

  static cutMessagePreview(text: string, length): string {
    if (!text) {
      return;
    }
    let sliced = text.slice(0, length);
    if (sliced.length < text.length) {
      sliced += '...';
    }
    return sliced;
  }

  static checkFileSize(file): string {
    const length = file.size.toString().length;
    let res: string;
    if (length <= 3) {
      return (res = `${file.size} bytes`);
    } else if (length > 3 && length <= 6) {
      return (res = Math.round(file.size / 1000).toString() + 'KB');
    } else if (length > 6 && length <= 9) {
      return (res = Math.round(file.size / 1000000).toString() + 'MB');
    }
    return res;
  }
}



// WEBPACK FOOTER //
// ./app/helpers/helpers.ts